import { memo } from 'react';

import { Box } from '@mui/material';

export const StepHeaderDivider = memo(() => (
  <Box
    role="separator"
    aria-orientation="vertical"
    sx={{
      width: '1px',
      height: 40,
      bgcolor: 'divider',
      flexShrink: 0,
      alignSelf: 'center',
    }}
  />
));

StepHeaderDivider.displayName = 'StepHeaderDivider';
